(() => {
  const initialise = (root) => {
    if (root.dataset.heartInitialised) return;
    root.dataset.heartInitialised = 'true';
    const input = root.querySelector('[data-heart-name]');
    const preview = root.querySelector('[data-heart-preview]');
    const variants = JSON.parse(root.querySelector('[data-heart-variants]').textContent);
    const messages = JSON.parse(root.querySelector('[data-heart-messages]').textContent);
    const error = root.querySelector('[data-heart-error]');
    const add = root.querySelector('[data-heart-add]');
    const money = (cents) => new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    const update = () => {
      const name = input.value.normalize('NFC').trim();
      const count = Array.from(new Intl.Segmenter('nl', { granularity: 'grapheme' }).segment(name)).filter(({ segment }) => /\S/u.test(segment)).length;
      const basePrice = Number(root.querySelector('[name="heart_size"]:checked').dataset.heartPrice);
      const size = root.querySelector('[name="heart_size"]:checked').value;
      const variant = variants.find((v) => v.options[0] === size && v.options[1] === String(count));
      let issue = '';
      if (count > 20) issue = messages.long;
      else if (!variant) issue = messages.unavailable;
      else if (!variant.available) issue = messages.sold_out;
      add.disabled = Boolean(issue);
      input.setCustomValidity(issue);
      input.setAttribute('aria-invalid', String(Boolean(issue && input.value)));
      error.textContent = issue;
      error.hidden = !issue || !input.value;
      root.querySelector('[data-heart-variant]').value = !issue && variant ? variant.id : '';
      preview.textContent = name || input.dataset.emptyPreview;
      root.querySelector('[data-heart-letter-count]').value = count;
      root.querySelector('[data-heart-count-label]').textContent = '(' + count + ')';
      root.querySelector('[data-heart-base-price]').textContent = money(basePrice);
      const totalPrice = variant ? variant.price : basePrice;
      root.querySelector('[data-heart-fee]').textContent = money(totalPrice - basePrice);
      root.querySelector('[data-heart-price-preview]').textContent = money(totalPrice);
    };
    input.addEventListener('input', update);
    root.querySelectorAll('[name="heart_size"]').forEach((radio) => {
      radio.addEventListener('change', update);
    });
    root.querySelector('form').addEventListener('submit', (event) => {
      update();
      if (add.disabled) {
        event.preventDefault();
        input.reportValidity();
        return;
      }
      input.value = input.value.normalize('NFC').trim();
    });
    root.querySelectorAll('[data-heart-image]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = root.querySelector('.gs-featured');
        image.removeAttribute('srcset');
        image.src = button.dataset.heartImage;
        image.alt = button.dataset.heartAlt || '';
        root.querySelectorAll('[data-heart-image]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    update();
  };
  const initialiseAll = () => document.querySelectorAll('[data-heart-product]').forEach(initialise);
  initialiseAll();
  document.addEventListener('shopify:section:load', initialiseAll);
})();
